import { IMainPhoto, IUserPhotoData } from 'redhotpie-shared-lib/interfaces/IUser';
import { Dispatch } from 'redux';
import * as conversationDetailAction from '../../redhotpie-shared-lib/actions/conversationDetailAction';
import * as types from '../constants/actionTypes';
import { PROFILE_SEARCH_TYPE, PROFILE_SEARCH_TYPE_INDEX, TIMEOUT_GET_USERS_ACTIVE_API } from '../constants/constants';
import * as messageUtils from '../functions/messageUtils';
import { removePrefixAndSuffix } from '../functions/messageUtils';
import ImageDuration from '../models/imageDuration';
import MessengerTheme from '../models/messengerTheme';
import userService from '../services/userService';
import * as myStore from '../store/myStore';
import { CreateUserInvite } from '../types/invites';
import { updateUserRemainingInvitesCredit } from './boostActions';
import { updateCommonStateReducerSuccess, updateErrorCallAPI, updateMessageNotificationError } from './commonStateAction';
import * as conversationInboxAction from './conversationInboxAction';
import * as groupActions from './groupChatActions';
import { updateProfile } from './loginActions';
import { updateUserDetailInGroupChatMessage } from './messageActions';
import { IUserLoginInfo } from '../interfaces/IUser';

const configApp = require('../../app');

const isNative = !configApp || !configApp.isWebApp;

export function updateUsersStateSuccess(data: any) {
  return { type: types.UPDATE_USERS_STATE_SUCCESS, data };
}

function getUsersReducer() {
  return myStore.getStore().getState().usersReducer;
}

export function getUsersActiveRequest(params: any) {
  return { type: types.GET_ACTIVE_USERS_REQUEST, data: params };
}

export function toggleHasFilteredUsersActiveStatus(status: boolean | any) {
  return {
    type: types.TOGGLE_HAS_FILTERED_USERS_ACTIVE_STATUS,
    data: !!status,
  };
}

export function getUsersActiveByFilterRequest() {
  return { type: types.GET_ACTIVE_USERS_BY_FILTER_REQUEST };
}

export function getUsersActiveFailed() {
  return { type: types.GET_ACTIVE_USERS_FAILED };
}

export function getUsersActiveByFilteredFailed() {
  return { type: types.GET_ACTIVE_USERS_FILTERED_FAILED };
}

export function getUsersActiveByFilterSuccess(data: any) {
  return { type: types.GET_ACTIVE_USERS_FILTERED_SUCCESS, data };
}

export function getUsersActiveSuccess(data: any) {
  return { type: types.GET_ACTIVE_USERS_SUCCESS, data };
}

export function toggleReportPopup(data: any, v2: boolean = false) {
  return { type: types.TOGGLE_REPORT_POPUP, data, v2 };
}

export function toggleReportPostPopup(data: any, v2: boolean = false) {
  return { type: types.TOGGLE_REPORT_POPUP_POST, data, v2 };
}

export function toggleNoProfilePhotoPopup(data: any) {
  return { type: types.TOGGLE_NO_PHOTO_POPUP, data };
}

export function toggleProfileModal(data: any) {
  return { type: types.TOGGLE_PROFILE_MODAL, data };
}

export function getFriendsFavoritesRequest(params?: any) {
  return { type: types.GET_FRIENDS_FAVORITES_REQUEST, params };
}

export function getFriendsFavoritesFailure(params?: any) {
  return { type: types.GET_FRIENDS_FAVORITES_FAILURE, params };
}

export function getFriendsFavoritesSucess(data: any, isNotUpdateWhenNoData: boolean = false) {
  return {
    type: types.GET_FRIENDS_FAVORITES,
    data,
    isNotUpdateWhenNoData,
  };
}

export function getUserLivenessResult(sessionID: string, isCouple: boolean, isFirst: boolean) {
  return (dispatch: Dispatch<any>) => {
    return userService.getUserLivenessResult(sessionID).then(res => {
      if (res.success) {
        if (!isCouple) {
          dispatch(updateProfile(undefined, true));
        } else {
          !isFirst && dispatch(updateProfile(undefined, true));
        }
      }
      return res;
    });
  };
}

export function getProfileSuccess(data: any) {
  return { type: types.GET_PROFILE_SUCCESS, data };
}

export function getMainPhotoSuccess(
  data: IMainPhoto,
  userId: number
): {
  type: typeof types.GET_MAIN_PHOTO_SUCCESS;
  data: { data: IMainPhoto; userId: number };
} {
  return { type: types.GET_MAIN_PHOTO_SUCCESS, data: { data, userId } };
}

export function getUsersMemberSearchSuccess(data: any) {
  return { type: types.GET_USERS_MEMBER_SEARCH_SUCCESS, data };
}

export function addFavoriteSuccess(user: any) {
  return { type: types.ADD_FAVORITE, data: user };
}

export function removeFavoriteSuccess(data: any) {
  return { type: types.REMOVE_FAVORITE, data };
}

export function blockUserSuccess(id: any) {
  return { type: types.BLOCK_USER, data: id };
}

export function updateFilterOptionFriendAndFavoriteSuccess(data: any) {
  return { type: types.UPDATE_FILTER_FRIEND_AND_FAVORITE, data };
}

export function loadMoreFriendsAndFavouritesSuccess() {
  return { type: types.LOAD_MORE_FRIENDS_FAVORITES, data: {} };
}

export function getMatchingUsersSuccess(data: any) {
  return { type: types.GET_MATCHING_USERS_SUCCESS, data };
}

export function addMatchingUserSuccess(userId: any) {
  return { type: types.ADD_MATCHING_USER_SUCCESS, data: userId };
}

export function checkMatchingProfileSuccess(isMatch: boolean, xmppId: any) {
  return { type: types.CHECK_MATCHING_PROFILE_SUCCESS, data: isMatch, xmppId };
}

export function getProfileGroupChatSuccess(data: any) {
  return { type: types.GET_PROFILE_GROUP_CHAT_SUCCESS, data };
}

export function updateUserWhoBlockMeListSuccess(data: number[]) {
  return { type: types.GET_USERS_WHO_BLOCK_ME, data };
}

export function getUsersBlockedSuccess(data: IUserLoginInfo[]) {
  return { type: types.GET_USERS_BLOCKED, data };
}

export function updateMessengerPermissionRequest() {
  return { type: types.UPDATE_MESSENGER_PERMISSION_REQUEST };
}

export function updateMessengerPermissionFailed() {
  return { type: types.UPDATE_MESSENGER_PERMISSION_FAILED };
}

export function updateMessengerPermissionSuccess(data: any) {
  return {
    type: types.UPDATE_MESSENGER_PERMISSION_SUCCESS,
    data: [
      {
        dataKey: ['userInfo', 'messenger', 'canReceivePhotos'],
        dataValue: data.CanReceivePhotos,
      },
      {
        dataKey: ['userInfo', 'messenger', 'canReceiveGifts'],
        dataValue: data.CanReceiveGifts,
      },
      {
        dataKey: ['userInfo', 'messenger', 'permissionMessageReceive'],
        dataValue: data.PermissionMessageReceive,
      },
      {
        dataKey: ['userInfo', 'messenger', 'permissionVideoCall'],
        dataValue: data.PermissionVideoCall,
      },
      {
        dataKey: ['userInfo', 'messenger', 'defaultFolder'],
        dataValue: data.DefaultFolder,
      },
      {
        dataKey: ['userInfo', 'messenger', 'defaultImageDuration'],
        dataValue: ImageDuration.getImageDurationFromEnum(data.DefaultImageDuration),
      },
      { dataKey: ['userInfo', 'messenger', 'theme'], dataValue: MessengerTheme.mappingObject(data.Theme) },
    ],
  };
}

export function updateChatRoomMessengerPermissionSuccess(data: any) {
  return {
    type: types.UPDATE_CHATROOM_MESSENGER_PERMISSION_SUCCESS,
    data: [
      {
        dataKey: ['userInfo', 'chatroomSettings', 'permissionMessageReceive'],
        dataValue: data.PermissionMessageReceive,
      },
      {
        dataKey: ['userInfo', 'chatroomSettings', 'isSoundEnabled'],
        dataValue: data.IsSoundEnabled,
      },
    ],
  };
}

export function toggleUserInLiveStream(status: any) {
  return {
    type: types.SET_STATUS_USER_IN_LIVE_STREAM,
    data: !!status,
  };
}

export function updateIsStreaming(isStreaming: boolean) {
  return { type: types.UPDATE_IS_STREAMING, data: isStreaming };
}

export function toggleUserInVideoCall(status: any) {
  return {
    type: types.SET_STATUS_USER_IN_VIDEO_CALL,
    data: !!status,
  };
}

export function updateTempDisplayDataFriendAndFavSuccess(data: any, index: number) {
  return {
    type: types.UPDATE_TEMP_DISPLAY_DATA_FRIEND_AND_FAV_SUCCESS,
    data,
    index,
  };
}

export function updateTempDataFriendAndFavToDisplay() {
  return {
    type: types.UPDATE_TEMP_DATA_FRIEND_AND_FAV_TO_DISPLAY_SUCCESS,
  };
}

export function updateTempDisplayDataFriendAndFav(data: any, index: number) {
  return (dispatch: Dispatch<any>) => {
    if (data && index) {
      dispatch(updateTempDisplayDataFriendAndFavSuccess(data, index));
    }
  };
}

export function getExistItemForAllFilterOption() {
  return (dispatch: Dispatch<any>) => {
    dispatch(getFriendsFavoritesRequest());
    userService
      .getAllFriendsFavorites({ type: PROFILE_SEARCH_TYPE.Active }, [])
      .then(res1 => {
        if (res1.success) {
          // if(res1.data.items.length > 0){
          if (res1.data.items.length > 0) {
            const currentFilterIndex = myStore.getStore().getState().friendsAndFavoritesReducer.filterIndex;
            if (currentFilterIndex === PROFILE_SEARCH_TYPE_INDEX.Active) {
              dispatch(updateFilterOptionFriendAndFavorite(PROFILE_SEARCH_TYPE_INDEX.Active));
              dispatch(getFriendsFavoritesSucess(res1.data.items));
            }
            dispatch(updateTempDisplayDataFriendAndFav(res1.data.items, PROFILE_SEARCH_TYPE_INDEX.Active));
          } else {
            userService.getAllFriendsFavorites({ type: PROFILE_SEARCH_TYPE.MutualMatch }, []).then(res2 => {
              if (res2.success) {
                if (res2.data.items.length > 0) {
                  const currentFilterIndex = myStore.getStore().getState().friendsAndFavoritesReducer.filterIndex;
                  if (currentFilterIndex === PROFILE_SEARCH_TYPE_INDEX.MutualMatch) {
                    dispatch(updateFilterOptionFriendAndFavorite(PROFILE_SEARCH_TYPE_INDEX.MutualMatch));
                    dispatch(getFriendsFavoritesSucess(res2.data.items));
                  }
                  dispatch(updateTempDisplayDataFriendAndFav(res2.data.items, PROFILE_SEARCH_TYPE_INDEX.MutualMatch));
                } else {
                  userService.getAllFriendsFavorites({ type: PROFILE_SEARCH_TYPE.Favourites }, []).then(res3 => {
                    if (res3.success) {
                      const currentFilterIndex = myStore.getStore().getState().friendsAndFavoritesReducer.filterIndex;
                      if (currentFilterIndex === PROFILE_SEARCH_TYPE_INDEX.Favourites) {
                        dispatch(updateFilterOptionFriendAndFavorite(PROFILE_SEARCH_TYPE_INDEX.Favourites));
                      }
                      dispatch(getFriendsFavoritesSucess(res3.data.items));
                      dispatch(updateTempDisplayDataFriendAndFav(res3.data.items, PROFILE_SEARCH_TYPE_INDEX.Favourites));
                    } else {
                      throw new Error('error');
                    }
                  });
                }
              } else {
                throw new Error('error');
              }
            });
          }
        } else {
          throw new Error('error');
        }
      })
      .catch(error => {
        dispatch(getFriendsFavoritesFailure());
      });
    // Promise.all([
    //     userService.getAllFriendsFavorites({type: PROFILE_SEARCH_TYPE.Active}, [])
    //     , userService.getAllFriendsFavorites({type: PROFILE_SEARCH_TYPE.MutualMatch}, [])
    //     , userService.getAllFriendsFavorites({type: PROFILE_SEARCH_TYPE.Favourites}, [])
    // ]).then(([res1, res2, res3]) => {
    //     const success = res1.success && res2.success && res3.success;
    //
    //     if (success) {
    //         let items = res1.data.items;
    //         let filterIndex = PROFILE_SEARCH_TYPE_INDEX.Active;
    //         if(items.length ===0 ){
    //             if (res2.data.items.length > 0) {
    //                 items = res2.data.items;
    //                 filterIndex = PROFILE_SEARCH_TYPE_INDEX.MutualMatch;
    //             }
    //             else {
    //                 if (res3.data.items.length > 0) {
    //                     items = res3.data.items;
    //                     filterIndex = PROFILE_SEARCH_TYPE_INDEX.Favourites;
    //
    //                 }
    //             }
    //         }
    //
    //         dispatch(updateFilterOptionFriendAndFavoriteSuccess(filterIndex));
    //         dispatch(getFriendsFavoritesSucess(items));
    //         return;
    //     }
    //     dispatch(getFriendsFavoritesFailure());
    // })
  };
}

export function getFriendsFavorites(params: any, isNotUpdateWhenNoData: boolean = false) {
  return (dispatch: Dispatch<any>) => {
    dispatch(getFriendsFavoritesRequest());
    return userService
      .getAllFriendsFavorites(params, [])
      .then(res => {
        if (res.success) {
          dispatch(getFriendsFavoritesSucess(res.data.items, isNotUpdateWhenNoData));
          return res;
        }
        // else {
        //   dispatch(getFriendsFavoritesSucess([], defaultActiveNow));
        //   console.log("Error: userAction/getFriendsFavorites", res.message);
        // }

        dispatch(getFriendsFavoritesFailure());
        return res;
      })
      .catch(() => dispatch(getFriendsFavoritesFailure()));
  };
}

export function getProfile() {
  return (dispatch: Dispatch<any>) => {
    const { userId } = myStore.getStore().getState().loginReducer.userInfo;
    return userService.getProfileSummary(userId).then(res => {
      if (res.success) {
        dispatch(getProfileSuccess(res.data));
      } else {
        console.log('Error: userAction/getProfile', res.message);
      }
    });
  };
}

export function getMainPhotoRequest(): {
  type: typeof types.GET_MAIN_PHOTO_REQUEST;
} {
  return { type: types.GET_MAIN_PHOTO_REQUEST };
}

export function getMainPhoto(userId: number) {
  return async (
    dispatch: Dispatch<{
      type: typeof types.GET_MAIN_PHOTO_REQUEST | typeof types.GET_MAIN_PHOTO_SUCCESS;
      data?: { data: IMainPhoto; userId: number };
    }>
  ) => {
    const userPhotoDataLocal = myStore
      .getStore()
      .getState()
      .usersReducer.data.find((item: IUserPhotoData) => {
        return item.userId === userId;
      });
    if (userPhotoDataLocal) {
      return Promise.resolve({ success: true, data: userPhotoDataLocal });
    }
    dispatch(getMainPhotoRequest());
    if (userId) {
      const res = await userService.getMainPhoto(userId);
      if (res.success && res.data) {
        dispatch(getMainPhotoSuccess(res.data, userId));
      }
      return res;
    }
    return Promise.resolve({ success: false });
  };
}

export const getUsersProfile = (params: any) => (dispatch: Dispatch<any>) => {
  userService.getUsersProfile(params).then(res => {
    if (res.success) {
      dispatch(getUsersMemberSearchSuccess(res.data));
    } else {
      console.warn('ERROR: userAction/getUsers', res.message);
    }
  });
};

export function updateFilterOptionFriendAndFavorite(filterIndex: number) {
  return (dispatch: Dispatch<any>) => {
    return dispatch(updateFilterOptionFriendAndFavoriteSuccess(filterIndex));
  };
}

export function addFavorite(userModel: any) {
  return (dispatch: Dispatch<any>) => {
    dispatch(addFavoriteSuccess(userModel));
    // TODO BACKUP
    // return userService.addFavorite(params).then(res => {
    //   if (res.success) {
    //     dispatch(addFavoriteSuccess(res.data));
    //   }
    //   else{
    //     console.warn("ERROR: userAction/addFavorite", res.message);
    //   }
    // });
  };
}

export function removeFavorite(params: any) {
  return (dispatch: Dispatch<any>) => {
    // return new Promise((resolve , reject)=>{
    //   userService.removeFavorite(params).then(res => {
    //     if (res.success) {
    //       dispatch(removeFavoriteSuccess(res.data.Profiles));
    //     }
    //     else{
    //       console.warn("ERROR: userAction/removeFavorite", res.message);
    //     }
    //     return resolve(res);
    //   }).catch(e =>{
    //     console.warn("ERROR: userAction/removeFavorite" , e.message);
    //   });
    // });

    dispatch(removeFavoriteSuccess(params));

    // TODO BACKUP
    // return userService.removeFavorite(params).then(res => {
    //   if (res.success) {
    //     dispatch(removeFavoriteSuccess(res.data.Profiles));
    //   }
    //   else{
    //     console.warn("ERROR: userAction/removeFavorite", res.message);
    //   }
    // }).catch(e =>{
    //   console.warn("ERROR: userAction/removeFavorite" , e.message);
    // });
  };
}

export function blockUser(userId: string | number, callback?: Function, lastMessageInConversationId = '', anotherParams?: any) {
  return (dispatch: any, getState: any) => {
    let conversation = null;
    const conversations = getState().conversationsReducer.data;
    conversation = conversations.find((x: any) => x.peerVcard.userId + '' === removePrefixAndSuffix(userId));
    // send socket block user in public group chat
    const currentGroupChat = getState().groupChatReducer.selectedGroup;
    if (currentGroupChat && currentGroupChat.roomJid) {
      dispatch(groupActions.sendBlockedUser(currentGroupChat.roomJid, userId));
    }
    if (conversation) {
      dispatch(
        conversationDetailAction.deleteConversation(
          conversation.peerVcard.xmppId,
          0,
          conversation.folders,
          conversation.pinned,
          lastMessageInConversationId
        )
      ).then(() => {
        // Blocked user appear in messenger list after few second -> did not found exactly issues
        const { selectedPeerVcard } = getState().conversationsReducer;
        if (selectedPeerVcard && (selectedPeerVcard.userId === userId || selectedPeerVcard.userId + '' === removePrefixAndSuffix(userId))) {
          dispatch(conversationInboxAction.resetSelectedConversation());
        }
      });
    }
    let userSendAPI = userId;
    // send socket block user in private group chat
    if (anotherParams && anotherParams.isPrivateGroup) {
      const roomJid = `${userId}`;
      const { userIdBlocked } = anotherParams;
      userSendAPI = userIdBlocked;
      if (roomJid) {
        dispatch(groupActions.sendBlockedUser(roomJid, userIdBlocked));
      }
    }
    // Temp fix issue of block user in this function by call removePrefixAndSuffix to make sure that do not use xmppId in block service below.
    // TODO: need refactor this block function later
    return userService.blockUser(removePrefixAndSuffix(userId)).then(res => {
      if (res.success) {
        dispatch(getUsersBlocked()).then(() => {
          if (callback) {
            callback();
          }
        });
        const {
          commonStateReducer: { dataSpotlightModal },
        } = getState();
        if (dataSpotlightModal.length > 0) {
          const newData = dataSpotlightModal.filter((itm: any) => itm.detail.userId !== (anotherParams?.userIdBlocked || -1));
          dispatch(updateCommonStateReducerSuccess({ dataSpotlightModal: newData }));
        }
      } else {
        dispatch(updateErrorCallAPI());
        dispatch(updateMessageNotificationError('Error occurred while processing the request'));
      }
      return res;
    });
  };
}

// export function blockUser(userId, callback) {
//   return (dispatch: Dispatch<any>) => {
//     return userService.blockUser(userId).then((res) => {
//       if (res.success) {
//         dispatch(blockUserSuccess(res.data.id));
//         if (callback) {
//           callback();
//         }
//       }
//       else {
//         dispatch(updateErrorCallAPI('Error occurred while processing the request'));
//       }
//       return res;
//     });
//   };
// }

export function getUserWhoBlockMeList() {
  return (dispatch: Dispatch<any>) => {
    return userService.getUserWhoBlockMeList().then(res => {
      if (res.success) {
        dispatch(updateUserWhoBlockMeListSuccess(res.data.Profiles));
      }
      return res;
    });
  };
}

export function getUsersBlocked() {
  return (dispatch: Dispatch<any>) => {
    return userService.getUsersBlocked().then(res => {
      if (res.success) {
        dispatch(getUsersBlockedSuccess(res.data!));
      }
      return res;
    });
  };
}

export function loadMoreFriendsAndFavourites() {
  return (dispatch: Dispatch<any>) => {
    dispatch(loadMoreFriendsAndFavouritesSuccess());
  };
}

export function getMatchingUsers() {
  return (dispatch: Dispatch<any>) => {
    return userService.getMatchingUsers().then(res => {
      if (res.success) {
        return dispatch(getMatchingUsersSuccess(res.data.items));
      }
      console.log('ERROR: userAction/getMatchingUsers', res.message);

      return res;
    });
  };
}

export function addMatchingUser(xmppId: string) {
  return (dispatch: Dispatch<any>) => {
    return userService.addMatchingUser(xmppId).then(res => {
      if (res.success) {
        return dispatch(addMatchingUserSuccess(res.data.pMatchUserId));
      }
      console.log('ERROR: userAction/addMatchingUser', res.message);
      return res;
    });
  };
}

export function checkMatchingProfile(userId: number) {
  return (dispatch: Dispatch<any>) => {
    return userService.getProfileSummary(userId).then(res => {
      if (res.success) {
        if (res.data.isMatch) {
          dispatch(addMatchingUser(res.data.xmppId));
        }
        return dispatch(checkMatchingProfileSuccess(res.data.isMatch, res.data.xmppId));
      }
      console.log('ERROR: userAction/checkMatchingProfile', res.message);
      return res;
    });
  };
}

export function getUserProfile(userId: number, useOldData: any) {
  return (dispatch: Dispatch, getState: any) => {
    let user = null;
    if (useOldData) {
      user = getState().usersReducer?.users?.find((u: any) => u.userId === userId);
    }
    if (user) {
      return Promise.resolve({ success: true, data: user });
    }
    return userService.getProfileSummary(userId).then(res => {
      if (res && res.success && res.data) {
        if (res.data.xmppId) {
          dispatch(getProfileGroupChatSuccess(res.data));
          dispatch(updateUserDetailInGroupChatMessage(res.data));
        }
      }
      return res;
    });
  };
}

export function patchClientMessengerSettings(permission: any) {
  return (dispatch: Dispatch<any>) => {
    dispatch(updateMessengerPermissionRequest());
    return userService.patchUserMessengerSettings(permission).then(res => {
      if (res.success) {
        dispatch(updateMessengerPermissionSuccess(res.data));
      } else {
        dispatch(updateMessengerPermissionFailed());
        console.warn('ERROR: patchClientMessengerSettings', res.message);
      }
      return res;
    });
  };
}

export function patchClientChatRoomSettings(permission: any) {
  return (dispatch: Dispatch<any>) => {
    return userService.patchUserChatRoomSettings(permission).then(res => {
      if (res.success) {
        // console.log("userAction",res.data);
        dispatch(updateChatRoomMessengerPermissionSuccess(res.data));
      } else {
        console.warn('ERROR: patchClientMessengerSettings', res.message);
      }
      return res;
    });
  };
}

export function getMainPhotosRequest() {
  return { type: types.GET_MAIN_PHOTOS_REQUEST };
}

export function getMainPhotosFailed() {
  return { type: types.GET_MAIN_PHOTOS_FAILED };
}

export function getMainPhotosSuccess(data: any, userId: (number | string)[]) {
  return { type: types.GET_MAIN_PHOTOS_SUCCESS, data: { data, userId } };
}

export function getMainPhotos(userIds: number[] = []) {
  return (dispatch: Dispatch<any>) => {
    dispatch(getMainPhotosRequest());
    const currentUserIdAvailable = myStore
      .getStore()
      .getState()
      .usersReducer.data.map((item: any) => {
        return item.userId;
      });
    const userIdsQuery = userIds.filter(userId => {
      return currentUserIdAvailable.indexOf(userId) === -1;
    });
    if (userIdsQuery.length > 0) {
      return userService.getMainPhotos(userIdsQuery).then(res => {
        if (res.success) {
          const userIdsFailedPhoto = userIdsQuery.filter(i => !res?.userIDs?.includes(i));
          if (userIdsFailedPhoto && userIdsFailedPhoto.length > 0) {
            return Promise.all(userIdsFailedPhoto.map(uId => dispatch(getMainPhoto(uId)))).then(() => {
              dispatch(getMainPhotosSuccess(res.data, res.userIDs || []));
              return res;
            });
          }
          dispatch(getMainPhotosSuccess(res.data, res.userIDs || []));
          return res;
        }
        dispatch(getMainPhotosSuccess([], []));
        return res;
      });
    }
    return new Promise(resolve => {
      dispatch(getMainPhotosSuccess([], []));
      resolve({});
    });
  };
}

export function updateUserStatusSuccess(userId: number, online: boolean) {
  return {
    type: types.UPDATE_STATUS_CONVERSATION,
    online,
    userId,
  };
}

export function getUserStatus(userId: number) {
  return (dispatch: Dispatch<any>) => {
    return userService.getUserStatus(userId).then(res => {
      if (res && res.success) {
        dispatch(updateUserStatusSuccess(userId, res.data.isOnline));
      }
      return res;
    });
  };
}

export function updateUserLocation(lat: number | undefined, lng: number | undefined, offset: number) {
  return () => {
    return userService.updateUserLocation({ lat, lng, offset }).then(res => {
      return res;
    });
  };
}

export function checkUserOnline(xmppId: string) {
  const receiverXmppid = messageUtils.addPrefixAndSuffix(xmppId);
  return () => {
    return userService.checkUserOnline(receiverXmppid).then(res => {
      return res;
    });
  };
}

export function createUserToolTipSuccess(toolTipId: number) {
  return { type: types.CREATE_USER_TOOLTIP_SUCCESS, toolTipId };
}

export function createUserToolTip(toolTipId: number) {
  return (dispatch: Dispatch<any>) => {
    return userService.createUserToolTip(toolTipId).then(res => {
      dispatch(createUserToolTipSuccess(toolTipId));
      return res;
    });
  };
}

export function increaseViewCountFaceIDToolTipSuccess(toolTipId: number) {
  return { type: types.INCREASE_TOOLTIP_VIEW_COUNT_FACE_ID, toolTipId };
}

export function patchUpdateAccountFaceIDTooltips(toolTipId: string) {
  return (dispatch: Dispatch<any>) => {
    return userService.patchUpdateAccountTooltips(toolTipId).then(res => {
      dispatch(increaseViewCountFaceIDToolTipSuccess(Number(toolTipId)));
      return res;
    });
  };
}

export function checkIsThisUserMe(userId: number) {
  return () => {
    return userService.checkIsThisUserMe(userId).then(res => {
      return res;
    });
  };
}

/**
 *  We handling response data in direct component, not in reducer
 * @param params: {"seekingType":0,"minAge":0,"maxAge":0,"isMatch":false,"size":0,"page":0}
 * @returns {function(*): Promise<R>}
 */
export function getUsersActiveByFilter(params: any) {
  return (dispatch: Dispatch<any>) => {
    dispatch(getUsersActiveByFilterRequest());
    return userService.getUsersActive(params).then(res => {
      if (res && res.success) {
        dispatch(getUsersActiveByFilterSuccess(res.data));
      } else {
        dispatch(getUsersActiveByFilteredFailed());
      }
      return res;
    });
  };
}

/**
 *
 * @param params: {"size":0,"page":0}
 */
export function getUsersActive(params: any) {
  return (dispatch: Dispatch<any>) => {
    // Check time & size get active
    const size = params.size || 0;
    const usersReducer = getUsersReducer();
    const preSizeParam = usersReducer.sizeParamGetUserActive;
    if (size <= preSizeParam) {
      // console.log("size <= preSizeParam", size, preSizeParam)
      // We should check time request here, if pass less than 5 minutes, reject action
      const timePreRequest = usersReducer.timeGetRequestActiveAPI;
      const currentTime = new Date().getTime();
      // console.log("timePreRequest", timePreRequest)
      // console.log("currentTime - timePreRequest", currentTime - timePreRequest)
      // console.log("TIMEOUT_GET_USERS_ACTIVE_API * 60 * 1000", TIMEOUT_GET_USERS_ACTIVE_API * 60 * 1000)
      if (currentTime - timePreRequest < TIMEOUT_GET_USERS_ACTIVE_API * 60 * 1000) {
        // console.log("Time is not matched, please try later");
        return new Promise(resolve => resolve(null));
      }
    }

    dispatch(getUsersActiveRequest({ size, time: new Date().getTime() }));
    const _params = {
      seekingType: params.seekingType,
      size: params.size,
      googleMapPlace: { PlacesId: '', Types: [''] },
    };
    return userService.getUsersActive(_params).then(res => {
      if (res && res.success) {
        dispatch(getUsersActiveSuccess(res.data));
      } else {
        dispatch(getUsersActiveFailed());
      }
      return res;
    });
  };
}

export function getActiveUserPopularCountSuccess(data: any, googleMapPlaceID?: string) {
  return {
    type: types.GET_ACTIVE_USER_POPULAR_COUNT_SUCCESS,
    data,
    googleMapPlaceID,
  };
}

export function getActiveUserStateCount(googleMapPlaceID: string) {
  const placeId = googleMapPlaceID || undefined;
  return (dispatch: Dispatch<any>) => {
    return userService.getActiveUserStateCount(placeId).then(res => {
      if (res.success) {
        dispatch(getActiveUserPopularCountSuccess(res.data, placeId));
      } else {
        console.log('Error: eventActions/getEventPopularCount', res.message);
      }
      return res;
    });
  };
}

function deleteParentOwnedCommentSuccess(params: any) {
  return {
    type: types.DELETE_PARENT_OWNED_COMMENT,
    params,
  };
}
/**
 * Function delete comment for Events and Story
 * @param params: {
 *   commentId: string,
 *   from: string ; FROM_DELETE_COMMENT.EVENT, FROM_DELETE_COMMENT.STORY prop exists in constants.js
 * }
 * */
export function deleteParentOwnedComment(params: any) {
  return (dispatch: Dispatch<any>) => {
    return userService
      .deleteParentOwnedComment(params)
      .then(res => {
        if (res.success) {
          dispatch(deleteParentOwnedCommentSuccess(params));
        } else {
          console.log('Error: eventActions/deleteParentOwnedComment', res.message);
        }
        return res;
      })
      .catch(e => {
        console.log(`deleteParentOwnedComment: ${e}`);
      });
  };
}

export function createUserInvite(params: CreateUserInvite) {
  return (dispatch: Dispatch<any>) => {
    return userService.createUserInvite(params).then(res => {
      if (res.success) {
        dispatch(updateUserRemainingInvitesCredit(res.data?.status));
      } else {
        console.log('Error: userActions/createUserInvite', res.data?.inviteResponse);
      }
      return res;
    });
  };
}
